import { useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import TextInputIcon from "../Inputs/TextInputIcon";
import { useDispatch, useSelector } from "react-redux";
import { mentorPricingRate } from "../../services/mentorPricingRate";
import { setUser } from "../../redux/mentorSlice";
import Dollar from "../../images/svgs/Dollar";
import CustomButton from "../customButtom/CustomButton";

const validationSchema = Yup.object().shape({
  meeting15: Yup.number()
    .transform((value, originalValue) =>
        originalValue === "" ? undefined : value
      )
    .min(0, "Price cannot be negative")
    .required("Price is required"),
  meeting30: Yup.number()
    .transform((value, originalValue) =>
        originalValue === "" ? undefined : value
      )
    .min(0, "Price cannot be negative")
    .required("Price is required"),
  meeting45: Yup.number()
    .transform((value, originalValue) =>
        originalValue === "" ? undefined : value
      )
    .min(0, "Price cannot be negative")
    .required("Price is required"),
  meeting60: Yup.number()
    .transform((value, originalValue) =>
        originalValue === "" ? undefined : value
      )
    .min(0, "Price cannot be negative")
    .required("Price is required"),
});

const MentorPricingForm = () => {
  const dispatch = useDispatch();
  const mentorProfile = useSelector((state) => state.mentor);
  const mentorMeeting = useSelector(
    (state) => state?.mentor?.profile?.mentorMeeting
  );

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      meeting15: mentorMeeting?.["15minmeeting"],
      meeting30: mentorMeeting?.["30minmeeting"],
      meeting45: mentorMeeting?.["45minmeeting"],
      meeting60: mentorMeeting?.["60minmeeting"],
    },
  });

  useEffect(() => {
    reset({
      meeting15: mentorMeeting?.["15minmeeting"],
      meeting30: mentorMeeting?.["30minmeeting"],
      meeting45: mentorMeeting?.["45minmeeting"],
      meeting60: mentorMeeting?.["60minmeeting"],
    });
  }, [mentorMeeting, reset]);

  const onSubmit = async (data) => {
    const updatedPricing = await mentorPricingRate({
      "15minmeeting": data.meeting15,
      "30minmeeting": data.meeting30,
      "45minmeeting": data.meeting45,
      "60minmeeting": data.meeting60,
    });

    dispatch(
      setUser({
        ...mentorProfile,
        mentorMeeting: updatedPricing,
      })
    );
  };

  return (
    <div className="mx-auto">
      <h2 className="text-xl font-bold mb-4">Set Pricing</h2>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="grid sm:grid-cols-2 gap-4">
          <TextInputIcon
            label="15 Min Meeting"
            name="meeting15"
            type="number"
            required
            register={register}
            errors={errors}
            placeholder="Set Price"
            icon={<Dollar className={"text-black w-6"} />}
            iconPosition="left"
          />

          <TextInputIcon
            label="30 Min Meeting"
            name="meeting30"
            type="number"
            required
            register={register}
            errors={errors}
            placeholder="Set Price"
            icon={<Dollar className={"text-black w-6"} />}
            iconPosition="left"
          />

          <TextInputIcon
            label="45 Min Meeting"
            name="meeting45"
            type="number"
            required
            register={register}
            errors={errors}
            placeholder="Set Price"
            icon={<Dollar className={"text-black w-6"} />}
            iconPosition="left"
          />

          <TextInputIcon
            label="60 Min Meeting"
            name="meeting60"
            type="number"
            required
            register={register}
            errors={errors}
            placeholder="Set Price"
            icon={<Dollar className={"text-black w-6"} />}
            iconPosition="left"
          />
        </div>
        <div className="mt-3 flex justify-end w-full">
          <CustomButton
            type="submit"
            label={"Update Pricing"}
            buttonClass="bg-custom-gradient px-[20px] py-[9px] rounded-lg w-full sm:w-[138px]"
          />
        </div>
      </form>
    </div>
  );
};

export default MentorPricingForm;
